import { App } from "@app/interfaces"

/** Identity only, never expiry/roles. STANDARD login stores its user_id in JWT. */
export function postBotSessionIdentity(
  auth: App.AuthState | null | undefined,
): string | null {
  if (!auth?.token?.trim()) return null
  if (auth.type === App.AuthType.OIDC) {
    const sub = (auth.userInfo as App.OIDCUserInfo | undefined)?.sub
    if (sub) return `oidc:${sub}`
  } else if (auth.type === App.AuthType.STANDARD) {
    const info = auth.userInfo as App.UserAuth | undefined
    let userId = info?.user_id
    if (userId === undefined) {
      try {
        const payload = auth.token
          .split(".")[1]
          .replace(/-/g, "+")
          .replace(/_/g, "/")
        userId = JSON.parse(atob(payload)).user_id
      } catch {
        // Unknown identity fails closed: a changed credential cannot reuse data.
      }
    }
    if (userId !== undefined && userId !== null) return `standard:${userId}`
  }
  return `${auth.type}:unidentified:${auth.token}`
}
